import { useState, useEffect, useCallback} from 'react';
import axios from 'axios'


// const BACKEND_URL = "http://64.225.83.34:8080"
const BACKEND_URL = process.env.REACT_APP_BACKEND_URL

export const useAxiosGet = (path, params) => {
    const [data, setData] = useState(null);
    const [error, setError] = useState("");
    const [loaded, setLoaded] = useState(false);
    const domain = params?.domain;

    useEffect(() => {
      setData(null);
      setError("");
      setLoaded(false);

      if (!domain) {
        setLoaded(true);
        return;
      }

      if (!BACKEND_URL) {
        setError("REACT_APP_BACKEND_URL no está definida en el build");
        setLoaded(true);
        return;
      }

      (async () => {
        try {
          const response = await axios.get(
            `${BACKEND_URL}/api/${path}`,
            { params: { ...params, domain } }
          );
          setData(response.data);
        } catch (error) {
          console.error(error.message);
          setError(error.message);
        } finally {
          setLoaded(true);
        }
      })();
    // Solo `domain` en deps: el padre pasa `{ domain }` nuevo objeto cada render;
    // incluir `params` provocaría peticiones en bucle.
    // eslint-disable-next-line react-hooks/exhaustive-deps -- params acotado a domain vía extracción arriba
    }, [path, domain]);
    return { data, error, loaded };
  };

export const useAxiosPost = (path, queryParams) => {
    const [data, setData] = useState(null);
    const [error, setError] = useState("");
    const [loading, setLoading] = useState(false);

    const post = useCallback(async (body) => {
      setError("");
      setLoading(true);

      if (!BACKEND_URL) {
        setError("REACT_APP_BACKEND_URL no está definida en el build");
        setLoading(false);
        return null;
      }

      try {
        const response = await axios.post(
          `${BACKEND_URL}/api/${path}`,
          body,
          { params: queryParams }
        );
        setData(response.data);
        return response.data;
      } catch (error) {
        console.error(error.message);
        setError(error.response?.data?.detail || error.message);
        throw error;
      } finally {
        setLoading(false);
      }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [path, queryParams?.token]);

    return { post, data, error, loading };
  };